import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  connect() {
    new TomSelect(this.element, {
      plugins: {'remove_button' : {},
                'checkbox_options': {
                  'checkedClassNames':   ['ts-checked'],
                  'uncheckedClassNames': ['ts-unchecked'],
                },
        	'clear_button':{
          'title':'Remove all selected options',
          }
      },
      placeholder: "Select Formats ...",
      hidePlaceholder: true,
      create: false,
    });
  }
}
